import React from "react";
import styled from "styled-components";
import { categories } from "../../data";
import CategoryItem from "./CategoryItem"
import {mobileUsual} from '../../responsive'
const Container = styled.div` 
    display: flex;
    justify-content: space-between;
    border-bottom: 5px solid #f59e42;
    margin-bottom: 0;
    padding-bottom: 0;
    overflow: hidden;
    margin-top: 3px;
    ${mobileUsual({ padding: "0px", flexDirection:"column" })}
`;

const Categories = () => {
  return (
    <Container>
      {categories.map((item) => (
        <CategoryItem item={item} key={item.id}/>
      ))}
    </Container>
  );
};

export default Categories;
